<template>
  <div>
    <b-button variant="link" class="float-right" @click="questionModal = true">
      <i class="mdi mdi-plus"></i>
      {{ $t("question.new") }}
    </b-button>

    <div>
      <h2>{{ $t("question.library") }}</h2>
    </div>
    <div class="bg-white">
      <table class="table table-bordered table-striped">
        <thead class="bg-secondary text-white">
          <tr>
            <th style="width: 100px">
              <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
                <template #button-content>
                  <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                </template>
                <b-dropdown-item href="#" @click="multipleDeleteById(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                  <i class="bx bx-trash-alt text-danger" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete") }} ({{ selectedItems.length }})
                </b-dropdown-item>
              </b-dropdown>
            </th>
            <sortable-table-head field="name" :text="$t('common.name')" :request="request" style="width: 400px;" />
            <th>{{ $t("question.answer-type.text") }}</th>
            <th>{{ $t("product.text") }}</th>
            <th>{{ $t("question.category.fwsed") }}</th>
            <th>{{ $t("common.type") }}</th>
            <th>{{ $t("common.created-by") }}</th>
            <th scope="col" style="width: 15%">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-white">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filterEnabled">
            <th></th>
            <th style="width: 100px;"><input class="form-control " v-model="nameFilter" /></th>
            <th></th>
            <th></th>
            <th>
              <select v-model="fwsedCategoryFilter" class="form-control">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <option value="TEST">{{ $t("firm.status.test") }}</option>
                <option value="PROD">{{ $t("firm.status.prod") }}</option>
                <option value="POST_PROD">{{ $t("firm.status.post-prod") }}</option>
              </select>
            </th>
            <th>
              <select class="form-control " v-model="scopeFilter">
                <option :value="undefined">{{ $t("common.all") }}</option>
                <option value="system">{{ $t("common.system") }}</option>
                <option value="workspace">{{ $t("common.workspace") }}</option>
              </select>
            </th>
            <th></th>
          </tr>

          <template v-if="pagination">
            <tr v-for="item in pagination.docs" :key="item._id">
              <td>
                <div class="text-center">
                  <b-form-checkbox v-model="selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                </div>
              </td>
              <td scope="row" class="text-break">{{ item.name | translate }}</td>
              <td class="text-nowrap" scope="row">
                <span v-if="item.answerType == 'SINGLE'">{{ $t("question.answer-type.single") }}</span>
                <span v-if="item.answerType == 'MULTIPLE'">{{ $t("question.answer-type.multiple") }}</span>
                <span v-if="item.answerType == 'FREE_TEXT'">{{ $t("question.answer-type.free-text") }}</span>
              </td>
              <td>{{ item.products && item.products.map(p => $t("product." + p.toLowerCase() + ".text")).join(", ") }}</td>

              <td>
                <span v-if="item.fwsedCategory"> {{ $t("firm.status." + item.fwsedCategory.toLowerCase().replace("_", "-")) }} </span>
              </td>

              <td>
                <span v-if="item.scope.value == 'workspace' && item.scope.workspace" v-b-tooltip.hover :title="item.scope.workspace.owner.name + '/' + item.scope.workspace.name">
                  <i class="text-muted mdi mdi-hexagon-multiple-outline"></i>
                  {{ item.scope.workspace.name }}
                </span>
                <span v-else v-b-tooltip.hover :title="$t('library.belonging-to-the-system')">
                  <i class="text-muted mdi mdi-database"></i>
                  {{ item.scope.value }}
                </span>
              </td>

              <td>{{ item.scope.createdBy ? item.scope.createdBy.name : "-" }}</td>
              <td>
                <div class="font-size-16 text-center" v-if="selectedItems.length == 0">
                  <i class="bx bx-trash-alt text-danger hand mr-3" v-b-tooltip.hover :title="$t('common.delete')" @click="deleteById(item)"></i>
                  <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <b-modal id="modal-multiple-delete-operation" centered :title="$t('common.multiple-delete-operation')" hide-footer>
      <div v-if="deleteOperationResult.success.length > 0">
        <h5 class="text-success">
          {{ $t("common.delete-items") }}
        </h5>
        <ul>
          <li v-for="item in deleteOperationResult.success" :key="item.id">
            {{ item | translate }}
          </li>
        </ul>
      </div>

      <div v-if="deleteOperationResult.failed.length > 0">
        <h5 class="text-danger mt-4">{{ $t("common.delete-failed") }}</h5>
        <ul>
          <li v-for="item in deleteOperationResult.failed" :key="item.id">
            <b> {{ item.name | translate }}</b>
            {{ item.error }}
          </li>
        </ul>
      </div>
    </b-modal>

    <content-loading v-if="loading" />

    <empty v-if="!loading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center" id="myText">
        {{ $t("common.not-found") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->
    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->

    <!--FORM-->

    <div class="backdrop2" :class="{ active: questionModal }" @click="questionModal = false">
      <div class="modal2" style="max-width: 70rem;" @click.stop>
        <div>
          <div class="d-flex flex-column justify-content-center align-items-center mb-4">
            <i class="modal--icon iconoir-chat-bubble-question mb-3"></i>
            <h6 class="modal--title">{{ $t("question.new") }}</h6>
          </div>

          <div class="mb-2">
            <label>{{ $t("question-set.products") }}</label>

            <b-form-tags v-model="form.products" size="lg" class="mb-2" add-on-change no-outer-focus>
              <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || !scopedProducts || scopedProducts.length === 0" :options="localizedScopedProducts">
                  <template #first>
                    <!-- This is required to prevent bugs with Safari -->
                    <option disabled value=""> {{ $t("product.text") }}</option>
                  </template>
                </b-form-select>

                <ul v-if="tags.length > 0" class="list-inline d-inline-block mt-2">
                  <li v-for="tag in tags" :key="tag" class="list-inline-item">
                    <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="primary">{{ $t("product." + tag.toLowerCase() + ".text") }}</b-form-tag>
                  </li>
                </ul>
                <b-form-text v-else>
                  <span class="text-danger">{{ $t("product.required") }}</span>
                </b-form-text>
              </template>
            </b-form-tags>

            <h6 class="mt-3">{{ $t("question.category.fwsed") }}</h6>

            <select v-model="form.fwsedCategory" class="form-control">
              <option value="TEST">{{ $t("firm.status.test") }}</option>
              <option value="PROD">{{ $t("firm.status.prod") }}</option>
              <option value="POST_PROD">{{ $t("firm.status.post-prod") }}</option>
            </select>

            <div class="mt-3">
              <sweet-input v-model="form.name" :isValid="!$v.form.name.$error" @input="$v.form.name.$touch()" layout="vertical" label="Soru Metni" class="mb-3" />
            </div>

            <h6 class="mt-3">ilişkili Tedbirler</h6>
            <filter-select
              key="questionFilter"
              id="questionFilter"
              ref="questionFilter"
              placeholder="İlişkili Tedbirler"
              :selected="form.policyDefinitions"
              :multiple="true"
              @filter="onPolicyDefinitionSearch"
              @changed="onPolicyDefinitionSelect"
            />

            <div class="d-flex flex-col flex-grow-1 mt-3">
              <h6>{{ $t("question.answer-type.text") }}</h6>

              <select v-model="form.answerType" class="form-control">
                <option value="SINGLE">{{ $t("question.answer-type.single") }}</option>
                <option value="MULTIPLE">{{ $t("question.answer-type.multiple") }}</option>
                <option value="FREE_TEXT">{{ $t("question.answer-type.free-text") }}</option>
              </select>
            </div>
          </div>

          <div class="mt-3">
            <b-form-checkbox v-model="form.fileRequired" switch>
              {{ $t("question.file-required") }}
            </b-form-checkbox>
            <small class="text-muted d-block mt-1">{{ $t("question.file-required-help") }}</small>
          </div>

          <div v-if="form.options.length > 0">
            <div class="added-questions" v-for="x in form.options" :key="x._id">
              <div class="d-flex align-items-center">
                <div class="pcard--actions">
                  <i class="iconoir-edit" @click="editOption(x)"></i>
                  <i class="iconoir-trash" @click="removeOption(x._id)"></i>
                </div>
                <h5 class="ml-4">
                  {{ x.name }}
                </h5>
              </div>
            </div>
            <hr />
          </div>

          <span v-if="form.answerType != 'FREE_TEXT' && !addNewOptionPanel" @click="addNewOptionPanel = true" class="hand text-primary">
            <i class="bx bx-plus"></i>
            {{ $t("question.add-option-panel") }}
          </span>

          <div class="modal-question-card" v-if="addNewOptionPanel">
            <div class="input-container w-100">
              <sweet-input v-model="optionName" :isValid="!$v.optionName.$error" @input="$v.optionName.$touch()" layout="vertical" label="Seçenek Metni" style="width: 100%;" />
            </div>

            <div>
              <div class="d-flex flex-wrap  justify-content-between">
                <b-button v-if="optionName" variant="main" @click="addOption()">{{ $t("question.add-option") }}</b-button>
                <b-button v-if="optionId" variant="secondary" @click="clearOptionForm()">{{ $t("question.cancel-edit") }}</b-button>
              </div>
            </div>
          </div>

          <div class="d-flex mt-4 mx-auto" style="gap: 0.75rem; width: max-content;">
            <button class="button cancel-button flex-shrink-0" @click="questionModal = false">
              {{ $t("common.cancel") }}
            </button>
            <button
              v-if="form.name && (form.answerType == 'FREE_TEXT' || (form.options && form.options.length > 0))"
              @click="save"
              class="button save-button flex-shrink-0"
              style="width: auto; padding: 0 1.2rem;"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!---->

    <!--FORM-->
  </div>
</template>

<script>
import { LibraryQuestionChannel } from "@/helpers/broadcastChannel";
import { required } from "vuelidate/lib/validators";

const state = "managementQuestion";

export default {
  components: {},
  validations: {
    form: {
      name: { required },
      options: { required },
    },
    optionName: { required },
  },
  data() {
    return {
      questionModal: false,

      form: {
        policyDefinitions: [],
        name: undefined,
        answerType: "SINGLE",
        fileRequired: false,
        fwsedCategory: "TEST",
        options: [],
      },

      optionName: undefined,
      optionId: undefined,

      addNewOptionPanel: false,
      //
      request: {
        options: { page: 1, limit: 15, sort: { "scope.workspace": "asc" } },
        query: {},
      },
      nameFilter: undefined,
      descriptionFilter: undefined,
      fwsedCategoryFilter: undefined,
      scopeFilter: undefined,
      filterEnabled: false,
      selectedItems: [],
    };
  },
  watch: {
    questionModal(v) {
      if (!v) {
        this.clearOptionForm();
        this.form = {
          name: undefined,
          answerType: "SINGLE",
          fileRequired: false,
          fwsedCategory: "TEST",
          options: [],
          policyDefinitions: [],
        };
      }
    },
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounceMixin(() => this.init());
      },
    },

    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },

    fwsedCategoryFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, fwsedCategory: { value: n, isObject: true } };
      } else {
        this.request.query["fwsedCategory"] = null;
        delete this.request.query["fwsedCategory"];
      }
    },
    descriptionFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        description: { value: n },
      };
    },
    scopeFilter(n, o) {
      if (n) {
        this.request.query = {
          ...this.request.query,
          "scope.value": { value: n, isObject: true },
        };
      } else {
        this.request.query["scope.value"] = null;
        delete this.request.query["scope.value"];
      }
    },
  },
  computed: {
    localizedScopedProducts() {
      if (!this.scopedProducts) return [];
      return this.scopedProducts.map((p) => {
        const val = typeof p === "string" ? p : p.value;
        return { value: val, text: this.$t("product." + val.toLowerCase() + ".text") };
      });
    },
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    deleteOperationResult() {
      return this.$store.getters[`${state}/deleteOperationResult`];
    },
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
  },
  async mounted() {
    const id = this.$route.query.id;
    if (id) {
      const response = await this.$store.dispatch(`${state}/findById`, id);
      this.edit(response.data);
    }
  },

  methods: {
    async onPolicyDefinitionSearch(value, callback) {
      const response = await this.$store.dispatch(`managementPolicy/paginate`, {
        options: { limit: 200 },
        query: {
          "scope.value": { value: "system", isObject: true },
          name: { value },
        },
      });
      callback(response.data?.docs ?? []);
    },
    onPolicyDefinitionSelect(value) {
      this.form.policyDefinitions = value;
    },
    addOption() {
      if (!this.optionId) {
        this.optionId = "id" + new Date().getTime();
      }
      this.form.options = [
        ...this.form.options.filter((i) => i._id != this.optionId),
        {
          _id: this.optionId,
          name: this.optionName,
        },
      ];

      this.clearOptionForm();
    },
    removeOption(id) {
      this.form.options = [...this.form.options.filter((i) => i._id != id)];
    },
    editOption(option) {
      this.optionName = option.name;
      this.optionId = option._id;
      this.addNewOptionPanel = true;
    },

    clearOptionForm() {
      this.optionName = undefined;
      this.optionId = undefined;

      this.addNewOptionPanel = false;
    },

    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }

      const form = {
        ...this.form,
        options: this.form.options.map((o) => {
          return {
            ...o,
            name: {
              [this.currentLanguage]: o.name,
            },
          };
        }),
      };

      try {
        await this.$store.dispatch(`${state}/save`, form);

        this.$toast.success(this.$t("common.success"));

        LibraryQuestionChannel.postMessage({ type: "library-question-updated", payload: { _id: form._id } });
        this.questionModal = false;
        this.init();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    ///
    init() {
      this.$store.dispatch(`${state}/paginate`, this.request);
      this.selectedItems = [];
    },
    rightPanelClosed() {
      this.$store.commit(`${state}/editedEntity`, null);
      this.init();
    },

    edit(item) {
      this.$store.commit(`${state}/editedEntity`, { ...item });
      //Fill Form
      this.questionModal = true;

      this.form = {
        _id: item._id,
        name: item.name[this.currentLanguage],
        answerType: item.answerType,
        products: item.products,
        fwsedCategory: item.fwsedCategory,
        fileRequired: !!item.fileRequired,
        policyDefinitions: item.policyDefinitions,

        options: item.options.map((i) => {
          return {
            ...i,

            name: i.name[this.currentLanguage],
          };
        }),
      };
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/delete`, item._id);
        this.init();
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.pagination.docs.slice();
      }
    },

    async multipleDeleteById(selectedItems) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/multipleDelete`, selectedItems);
        this.init();
        this.selectedItems = [];
        this.$root.$emit("bv::show::modal", "modal-multiple-delete-operation");
      } catch (error) {
        console.error(error);
      }
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./question-set";
@import "./organization-risk-decision.scss";
</style>
